import CancelAppointment from "./CancelAppointment";

export default CancelAppointment;